import gql from 'graphql-tag';
import GroupModerator from './group_moderator';
import S3Object from './s3_object';

export default gql`
  fragment UserProfile on UserProfile {
    id
    full_name
    job_title
    follower_count
    image {
      ...S3Object
    }
    leaderboard_enabled
    email_address
    email_address_verified
    user_type
    user_status
    user_pool_id
    client_id
    location_id
    location_title
    location {
      id
      title
      block_message
    }
    department_id
    department_title
    last_onboarding_step
    lang
    onboarding_completed
    last_accessed_at
    user_timezone
    created_at
    german_privacy
    reach
    group_moderator {
      ...GroupModerator
    }
    notification_delivery_types
    getstream_token
    push_notification_configuration {
      device_platform
      token
    }
    push_notifications_status {
      paused
      paused_at
    }
  }
  ${GroupModerator}
  ${S3Object}
`;
